import chroma, { lab, scale } from "chroma-js";
import { DataStore } from './domain/DataStore.js';
import { Polar } from './domain/Polar.js';

export const UI_STATE = {
    MAP: {
        RESET: "reset",
        PLAYING: "playing",
        READY_TO_PLAY: "readyToPlay",
        PAUSED: "paused"
    },
    TOOLS: {
        WAITING_FOR_USER_CLICK: "waiting for user click",
        INACTIVE:"inactive"
    },
    startPointCache: null
};

let _uiState = {}; // 'reset', 'readyToPlay','playing', 'paused'

export function setUIState(key,s) {
    _uiState[key] = s;
}

export function isUIState(key,s) {
    return _uiState[key] == s;
}

//Vessel and AIS Data
export const dataStore = new DataStore();

export function raceData() {
    return dataStore.getRace();
}

export function sharedFileMode() {
    return dataStore.isSharedFileMode();
}

const currentDomain = [                        3,       1,     0.5,    0,       -0.5,       -1,       -3].reverse();
const currentColors = chroma.scale(["black","blue","#1E90FF","white","yellow","red","purple"])
.domain(currentDomain);

// const spdDomain = [0,       3,        4.5,          5,      5.5,             6,        6.5,      7,        8,      9,      11,      14];
// const spdColorsArr = chroma.scale(["grey","1E90FF","blue","green"]).colors(5).concat(chroma.scale(["green","yellow","orange","red","purple"]).colors(6));
// const bsColors = chroma
//     .scale(spdColorsArr)
//     .domain(spdDomain);

const spdDomain = [0,       3,        4.5,          5,      5.5,             6,        6.5,      7,        8,      9,      11,      14];
const spdColorsArr = chroma.scale(["grey","1E90FF","blue","green"]).colors(5).concat(chroma.scale(["green","yellow","orange","red","purple"]).colors(6));
const bsColors = chroma
    .scale(spdColorsArr)
    .classes(spdDomain);

const polarPerfDomain = [75, 90, 95, 105, 115, 125];
const polarPerfColors = chroma.scale(["blue", "green", "yellow","orange","red", "purple"]).domain(polarPerfDomain);

    //chroma.scale('Viridis').colors(20)
//export const windColors = chroma.scale('Viridis').domain([2,4,8,10,12,16,20,24,28,36,40,50]);
const WIND_SERIES = [2, 4, 6, 8, 10, 12, 14, 16, 20, 25, 30, 40, 50];
export const windColors = chroma.scale(["grey","black","#1E90FF","blue","red","green","yellow","orange","red","purple"]).domain(WIND_SERIES);

export const windShiftColors = chroma.scale(["red","grey","green"]).domain([-3,0,3]);


export const TRACK_COLOR = {
    DEFAULT: chroma("grey").alpha(0.8).hex(),
    NO_DATA: chroma('grey').alpha(0.5).hex(),
    HIDDEN: chroma('grey').alpha(0.1).hex(),
};

export const TRACK_STYLE = {
    STW: { 
        name: "STW",
        colorMap: bsColors,
        colorDomain:spdDomain,
        title: "STW"
    },
    SOG: {
        name: "SOG",
        colorMap : bsColors,
        colorDomain:spdDomain,
        title: "SOG"
    },
    VMG: {
        name: "VMG",
        colorMap : bsColors,
        colorDomain:spdDomain,
        title: "VMG"
    },
    CURRENT: {
        name: "Current",
        colorMap: currentColors,
        colorDomain:currentDomain,
        title: "Current"
    },
    TWS: {
        name: "TWS",
        colorMap: windColors,
        colorDomain:WIND_SERIES,
        title: "TWS"
    },
    POLAR_PERF: {
        name: "POLAR_PERF",
        colorMap: polarPerfColors,
        colorDomain: polarPerfDomain,
        title: "Polar %",
        accessor: (frame) => frame.calc?.polarPerf
    }
};

export let _trackStyle = TRACK_STYLE.SOG;
export function setTrackStyle(s) {
    _trackStyle = s;
}

export function showLoadingSpinner() {
    document.getElementById('loading-spinner').style.display = 'flex';
    document.getElementById('loading-message').textContent = '';
}

export function hideLoadingSpinner() {
    document.getElementById('loading-spinner').style.display = 'none';
    document.getElementById('loading-message').textContent = '';
}

export async function setLoadingMessage(message) {
    console.warn("Spinner: "+message);
    if (typeof document !== 'undefined') {
        const el = document.getElementById('loading-message');
        if (el) el.textContent = message;
    }
    if (globalThis.scheduler?.yield) {
        try {
            await globalThis.scheduler.yield();
        } catch (e) {
            console.warn("scheduler.yield failed", e);
        }
    } else {
        console.log("No scheduler yield available!");
    }
}

const WIND_ANGLE_SERIES = [20,25,30,35,40,45,50,60,70,80,90,100,110,120,130,140,150,160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,315,320,325,330,335,340];
export function binValueWind(x) {
    let index = WIND_ANGLE_SERIES.findIndex(e => e >= x);
    if (index < 0)
        return WIND_ANGLE_SERIES[WIND_ANGLE_SERIES.length - 1];
    if (index == 0)
        return WIND_ANGLE_SERIES[0];

    index--;
    const nextIndex = index > WIND_ANGLE_SERIES.length - 1 ? 0 : index + 1;
    if (x - WIND_ANGLE_SERIES[index] >= WIND_ANGLE_SERIES[nextIndex] - x) {
        index = nextIndex;
    }
    let result = WIND_ANGLE_SERIES[index];
    if (result == 360) result = 0;
    return result;
}


export function binValueWindSpd(x) {
    let index = WIND_SERIES.findIndex(e => e >= x);
    if (index < 0)
        return WIND_SERIES[WIND_SERIES.length-1];
    if (index == 0)
        return WIND_SERIES[0];
    index--;
    const nextIndex = index > WIND_SERIES.length - 1 ? 0 : index + 1;
    if (x - WIND_SERIES[index] >= WIND_SERIES[nextIndex] - x) {
        index = nextIndex;
    }
    let result = WIND_SERIES[index];
    return result;
}
  



export function average(values) {
    return values.reduce((a, b) => parseFloat(a) + parseFloat(b), 0) / values.length;
}

export function median(values) {
    values.sort((a, b) => parseFloat(a) - parseFloat(b));
    return values[parseInt(values.length/2)];
}

/*
{
  tws: [4,8,12,16]
  twa: [
    {twa:0, boatSpeed:[0,0,0,0]},
    {twa:10, boatSpeed:[2.1,4,6,8]},
  ]
}
*/

// TODO refactor the polar logic into a Polar class or similar


export function generatePolarTraces(polar) {
    if (polar == null)
        return [{
            type:'scatterpolar',
            mode:"lines+markers",
            theta: [0],
            name:"TWS 2 kn",
            r: [0],
            line: { shape: 'spline', color: getColorForWind(2) }
        }];

    const polarStruct = polar.polarStruct || polar;
    const traces = [];
    for (let twsIdx = 0; twsIdx < polarStruct.tws.length; twsIdx++) {
        const tws = polarStruct.tws[twsIdx];
        const theta = [];
        const r = [];
        for (let twaIdx = 0; twaIdx < polarStruct.twa.length; twaIdx++) {
            const twaRec = polarStruct.twa[twaIdx];
            theta.push(twaRec.twa);
            r.push(twaRec.boatSpeed[twsIdx]);
        }
        traces.push({
            type: "scatterpolar",
            mode: "lines+markers",
            name: `TWS ${tws} kn`,
            theta: theta,
            r: r,
            line: { shape: 'spline', color: getColorForWind(tws) },
            marker: { color: getColorForWind(tws) }
        });
    }
    return traces;
}

export function createPolar(timeFrames, halfPolar) {
    return Polar.createFromTimeframes(timeFrames, halfPolar);
}
  
  export function binValue(x, step, range) {
    if (x < 0 || x > range) return null;
    return parseInt(Math.floor(x / step) * step);
  }

  
  export function getColorForWind(tws) {
    return windColors(tws).hex();
  }


export function createPolarText(polar) {
    const polarStruct = polar.polarStruct || polar;
    return new Polar(polarStruct).serialiseToText();
}

export function loadPolarFromText(polText) {
    return Polar.loadFromText(polText, null, null);
}

const _saveOrigHTML = new Map();
export function saveButtonSpinnerOn(saveButton) {
  _saveOrigHTML.set(saveButton.id, saveButton.innerHTML);
  saveButton.innerHTML =
    '<img src="icons/spinner.webp" alt="Saving..." style="height: 12px; vertical-align: middle;">';
  saveButton.disabled = true;
}

export function saveButtonSpinnerOff(saveButton) {
  saveButton.innerHTML = _saveOrigHTML.get(saveButton.id);
  saveButton.disabled = false;
}
